import React from "react";
import { FiltersNumberIndicator, ToggleButton, Wrapper } from "./styles";
import CustomButton from "../../../../components/CustomButton";
import { FiChevronDown } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";
import Select from "react-select";
import { SortOptions } from "../../enum";
import { useMediaQuery } from 'react-responsive';


interface IProps {
  isMapVisible: boolean;
  onToggleMap: () => void;
  onOpenFiltersModal?: () => void;
  onSortPropertiesByPrice?: (orderBy: SortOptions) => void;
  defaultSelectValue: SortOptions;
  filtersQuantity?: number;
}
const SORT_OPTIONS = [
  { label: SortOptions.NO_PREFERENCE, value: SortOptions.NO_PREFERENCE },
  { label: SortOptions.HIGHEST_PRICE, value: SortOptions.HIGHEST_PRICE },
  { label: SortOptions.LOWEST_PRICE, value: SortOptions.LOWEST_PRICE },
];


function FilterToggles({
  isMapVisible,
  onToggleMap,
  onOpenFiltersModal,
  onSortPropertiesByPrice = () => {},
  defaultSelectValue,
  filtersQuantity,
}: IProps) {

  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <Wrapper>
      {!isMobile && (
        <Select
          placeholder="Ordenar por"
          options={SORT_OPTIONS}
          defaultValue={{ label: defaultSelectValue, value: defaultSelectValue }}
          onChange={(e) => onSortPropertiesByPrice(e!.value)}
        />
      )}
      <CustomButton icon={<FiChevronDown />} onClick={onOpenFiltersModal}>
        Filtros
      </CustomButton>
      {filtersQuantity && (
        <FiltersNumberIndicator>{filtersQuantity}</FiltersNumberIndicator>
      )}
      <ToggleButton $active={isMapVisible} onClick={onToggleMap}>
        <HiOutlineLocationMarker />
      </ToggleButton>
    </Wrapper>
  );
}

export default FilterToggles;
